// extracted by mini-css-extract-plugin
export default {"tag":"TagV2_tag__kVgnd","tagInverted":"TagV2_tagInverted__iPXb7"};